:host {
  --dimension-icon-height: 16px;
  --dimension-icon-width: 16px;
  --color-icon-fill: currentColor;
  contain: strict;
  display: inline-block;
  fill: var(--color-icon-fill);
  height: var(--dimension-icon-height);
  width: var(--dimension-icon-width);
}
:host .pdsicon {
  fill: var(--color-icon-fill);
}

.pds-icon-fill-none {
  fill: none;
}

.icon-inner,
.pds-icon,
svg {
  display: block;
  height: 100%;
  width: 100%;
}